"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Typography_1 = require("@material-ui/core/Typography");
const styles_1 = require("@material-ui/core/styles");
const ArcadeCurrency_1 = require("./ArcadeCurrency");
const styles = (theme) => (0, styles_1.createStyles)({
    tag: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        height: 32,
        position: 'absolute',
        bottom: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
        paddingLeft: theme.spacing(),
        paddingRight: theme.spacing(),
        borderTopRightRadius: 10
    }
});
const ArcadeCardBanner = ({ prize, classes }) => ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.tag }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ color: 'secondary', variant: 'subtitle1', component: 'span' }, { children: prize })), (0, jsx_runtime_1.jsx)(ArcadeCurrency_1.default, { color: 'secondary' })] })));
exports.default = (0, styles_1.withStyles)(styles)(ArcadeCardBanner);
//# sourceMappingURL=ArcadeCardBanner.js.map